import { render, staticRenderFns } from "./PrescriptionDiagnosticModal.vue?vue&type=template&id=95ef1140&scoped=true"
import script from "./PrescriptionDiagnosticModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionDiagnosticModal.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionDiagnosticModal.vue?vue&type=style&index=0&id=95ef1140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef1140",
  null
  
)

export default component.exports